var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeading3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#464646",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.923 16V6.9H6.301V10.8H10.708V6.9H12.086V16H10.708V11.931H6.301V16H4.923ZM16.0687 16.156C15.4793 16.156 14.942 16.052 14.4567 15.844C13.98 15.6273 13.5987 15.3023 13.3127 14.869C13.0267 14.4357 12.875 13.894 12.8577 13.244H14.2227C14.24 13.7293 14.4047 14.141 14.7167 14.479C15.0373 14.8083 15.488 14.973 16.0687 14.973C16.6233 14.973 17.048 14.8213 17.3427 14.518C17.6373 14.206 17.7847 13.8203 17.7847 13.361C17.7847 12.8063 17.5853 12.3947 17.1867 12.126C16.7967 11.8573 16.3157 11.723 15.7437 11.723H15.0677V10.579H15.7567C16.268 10.579 16.6797 10.4577 16.9917 10.215C17.3123 9.97233 17.4727 9.63 17.4727 9.188C17.4727 8.81533 17.347 8.512 17.0957 8.278C16.853 8.044 16.5063 7.927 16.0557 7.927C15.5877 7.927 15.2193 8.06567 14.9507 8.343C14.682 8.61167 14.5347 8.94967 14.5087 9.357H13.1437C13.161 8.82833 13.291 8.369 13.5337 7.979C13.785 7.589 14.1273 7.28567 14.5607 7.069C14.994 6.85233 15.4923 6.744 16.0557 6.744C16.6623 6.744 17.1693 6.85233 17.5767 7.069C17.9927 7.277 18.3047 7.563 18.5127 7.927C18.7293 8.28233 18.8377 8.67233 18.8377 9.097C18.8377 9.58233 18.7033 10.007 18.4347 10.371C18.166 10.735 17.8063 10.9777 17.3557 11.099C17.8757 11.2117 18.3047 11.4673 18.6427 11.866C18.9807 12.256 19.1497 12.763 19.1497 13.387C19.1497 13.8897 19.0327 14.3533 18.7987 14.778C18.5647 15.194 18.218 15.5277 17.7587 15.779C17.2993 16.0303 16.736 16.156 16.0687 16.156Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeading3);
export default __webpack_public_path__ + "static/media/heading_3.2308b6f881caaabe58e03bdb4b5f832f.svg";
export { ForwardRef as ReactComponent };